import React from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import TuneIcon from "@mui/icons-material/Tune";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import { ReactComponent as Logo } from "../../assets/mLogo.svg";
import { Toolbar, Typography, IconButton, Box } from "@mui/material";
import { useSelector } from "react-redux";

const HeaderTop = ({ open, setOpen, notification, setNotification, profile, setProfile, setLogout, logout, company, setCompany }) => {
  // Access the selected company directly from Redux state
  const selectedCompany = useSelector((state) => state.company.selectedCompany);

  return (
    <div>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left section: Back button and page title */}
        {/* Center section: Company logo and name */}
        <Box className="userProfile" display="flex" alignItems="center">
          <Logo className="logo" />
          <Box className="userName">
            <Typography className="subtitle2" variant="subtitle2">
              Nome azienda
            </Typography>
            <Typography className="caption" variant="caption">
              {selectedCompany?.name || "Nessuna azienda selezionata"}
            </Typography>
          </Box>
          <MultipleStopIcon className="multipleStopIcon" onClick={() => setCompany(!company)} />
        </Box>

        {/* Right section: Action icons */}
        <Box className="headerTopIcons">
          <IconButton color="inherit" onClick={() => setNotification(!notification)}>
            <NotificationsNoneIcon />
          </IconButton>
          <IconButton color="inherit" onClick={() => setProfile(!profile)} >
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={() => setOpen(!open)}>
            <TuneIcon />
          </IconButton>
          <IconButton
            onClick={() => setLogout(!logout)}
          >
            <LogoutIcon className={logout ? "logoutActive" : "logoutBtn "} />
          </IconButton>
        </Box>
      </Toolbar>
    </div>
  );
};

export default HeaderTop;